export default "__VITE_ASSET__wsjEKmBM__$_?url__"